import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import { useRecordContext, useNotify, useRefresh } from 'react-admin';
import create from 'utils/api/create';

const NursysMenu = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isLoading, setIsLoading] = useState(false);

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  if (!record) {
    return null;
  }

  const handleNursysVerification = async () => {
    try {
      setIsLoading(true);
      const response = await create(
        `/v3/admin/professionals/${record.id}/nursys_verification`,
        {},
        'Professional',
      );
      notify(response?.data?.message ?? 'Success', { type: 'success' });
    } catch (error: any) {
      notify(error?.message ?? 'Error', { type: 'error' });
    } finally {
      setIsLoading(false);
      refresh();
      handleClose();
    }
  };

  const handleNursysSync = async () => {
    try {
      setIsLoading(true);
      const response = await create(
        `/v3/admin/professionals/${record.id}/nursys_sync`,
        {},
        'Professional',
      );
      notify(response?.data?.message ?? 'Success', { type: 'success' });
    } catch (error: any) {
      notify(error?.message ?? 'Error', { type: 'error' });
    } finally {
      setIsLoading(false);
      refresh();
      handleClose();
    }
  };

  return (
    <div>
      <Button size="small" variant="contained" onClick={handleClick} disabled={isLoading}>
        Actions ▼
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={handleNursysVerification}>
          {record.in_nursys_list ? 'Submit Nursys Verification' : 'Add To Nursys List'}
        </MenuItem>
        <MenuItem onClick={handleNursysSync}>Nursys Sync</MenuItem>
      </Menu>
    </div>
  );
};

export default NursysMenu;
